<template>
  <div class="success">
    <!-- 头图 -->
    <div class="headImgs">
      <img src="../../assets/imgs/auth/authImg.jpg" />
    </div>
    <div class="remark"></div>
    <ul class="centImg">
      <li v-for="(item, index) in images" :key="index">
        <img :src="item.url" alt />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      images: [
        // {
        //   url: require("@/assets/qrcodes/北京银行.png")
        // },
        {
          url: require("@/assets/qrcodes/changshuyh.png")
        },
        // ... 其他图片
        {
          url: require("@/assets/qrcodes/jiangsuyh.png")
        },
        // {
        //   url: require("@/assets/qrcodes/江西银行.png")
        // },
        {
          url: require("@/assets/qrcodes/jiaotongyh.png")
        },
        {
          url: require("@/assets/qrcodes/huaxiayh.png")
        },
        // ... 其他图片
        // {
        //   url: require("@/assets/qrcodes/昆山农商银行.png")
        // },
        {
          url: require("@/assets/qrcodes/nanjingyh.png")
        },
        {
          url: require("@/assets/qrcodes/ningboyh.png")
        },
        // ... 其他图片
        {
          url: require("@/assets/qrcodes/pufayh.png")
        },
        {
          url: require("@/assets/qrcodes/shanghaiyh.png")
        },
        {
          url: require("@/assets/qrcodes/suzhounsyh.png")
        },
        {
          url: require("@/assets/qrcodes/suzhouyn.png")
        },
        {
          url: require("@/assets/qrcodes/taicangyh.png")
        },
        // {
        //   url: require("@/assets/qrcodes/兴业银行.png")
        // },
        // ... 其他图片
        {
          url: require("@/assets/qrcodes/zjgnsh.png")
        },
        {
          url: require("@/assets/qrcodes/zsyh.png")
        },
        {
          url: require("@/assets/qrcodes/zhesyh.png")
        },
        {
          url: require("@/assets/qrcodes/zggsyh.png")
        },
        // ... 其他图片
        {
          url: require("@/assets/qrcodes/zgjsyh.png")
        },
        {
          url: require("@/assets/qrcodes/zgnyyh.png")
        },
        {
          url: require("@/assets/qrcodes/zgrbcx.png")
        },
        {
          url: require("@/assets/qrcodes/zhongguoyh.png")
        },
        // ... 其他图片
        {
          url: require("@/assets/qrcodes/zgyzyh.png")
        },
        {
          url: ""
        },
        {
          url: ""
        }
      ]
    };
  },
  mounted() {
    this.get_bodyHeight();
  },

  methods: {
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    }
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.success {
  background-color: #fff;
  .headImgs {
    img {
      width: 100%;
      height: 200px;
    }
  }
  .remark {
    height: 400px;
    width: 100%;
    margin-top: -4px;
    text-align: center;
    background-image: url("../../assets/imgs/index/xssq_img.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: rgb(0, 4, 122);
  }
  .centImg {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    box-sizing: border-box;
    margin-top: 20px;
    li {
      width: 400px;
      height: 350px;
      margin: 0 0 20px 0;
      //   box-shadow: 5px 5px 20px #cccc;
      text-align: center;
      img {
        width: 400px;
        // height: 350px;
      }
    }
  }
}
</style>